/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentTraceabilityViewModel } from "../types/IndividualPaymentTraceabilityViewModel.ts";

export const individualPaymentTraceabilityViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  username: z.string().nullish(),
  type: z.string().nullish(),
  entity: z.string().nullish(),
  entityId: z.string().nullish(),
  fieldName: z.string().nullish(),
  oldValue: z.string().nullish(),
  newValue: z.string().nullish(),
  date: z.string().datetime().nullish(),
}) as unknown as ToZod<IndividualPaymentTraceabilityViewModel>;
